import { IFinancialPosition } from '../sp-types/financialPositionType';
import { deleteItem, getItems, saveItem } from './genericFB';

const collection = 'financial-positions';

const generateId = ({ accountId, materialId }: IFinancialPosition, index?: number): string =>
  `${accountId}_${materialId}_${index || ''}_${new Date().getTime()}`;

export async function savePosition(position: IFinancialPosition, index?: number): Promise<IFinancialPosition | null> {
  return saveItem<IFinancialPosition>(generateId(position, index), position, collection);
}

export async function getPositions(accountId: string): Promise<IFinancialPosition[] | undefined> {
  return getItems<IFinancialPosition>(accountId, collection);
}

export async function deletePositions(accountId: string): Promise<void> {
  const items = await getItems<IFinancialPosition>(accountId, collection, undefined, true);

  await Promise.all(items?.map((item) => deleteItem(item.id, collection)) || []);

  console.log(`Deleted ${items?.length} documents where accountId == ${accountId}`);
}
